import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import './styles.css'
import TableArrowDown from 'component/svgComponents/tableArrowDown'

const NewTableSystemParameters = ({
  parameters,
  handleOrder,
  openModal,
  handleEditModal
}) => {
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  const [copiedRow, setCopiedRow] = useState(null);
  const [orders,setOrders] = useState([{id:"nuParameter", active: true, reverse: true},{id: "idBranch", active: false, reverse: false}])

  const changeOrder = (index, previousIndex) => {
    const newOrders = [...orders]
    
    if(newOrders[index].active) {
      newOrders[index].reverse = !newOrders[index].reverse
    }

    else {
      newOrders[index].active = true
      newOrders[previousIndex].active = false
    }

    setOrders(newOrders)
    const active = newOrders.find(or => or.active)
    const direction = active.reverse ? 'ASC' : 'DESC'
    handleOrder(active.id, direction)
  }

  const handleCopy = (rowIndex, valueToCopy) => {
    navigator.clipboard.writeText(valueToCopy).then(() => {
      setCopiedRow(rowIndex);

      setTimeout(() => setCopiedRow(null), 2000);
    });
  };

  // Pagination below table
  const PAGINATION_HEIGHT = 71
  // Search and Filter
  const TOP_ACTIONS = 95
  // TOOLBAR + Title
  const TOP_BAR = 67 + 50

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])

  const renderHeader = () => (
      <tr className='pictograms-tr'>
       <th style={{cursor: 'pointer', width: "12%" }} 
           onClick={() => changeOrder(1,0)}>
            Lojas  
            <TableArrowDown 
            active={orders[1].active} 
            reverse={orders[1].reverse} 
            className={`leftMargin ${orders[1].reverse ? 'arrow-margin-bottom' : ''}`}
            />
       
       </th>

       <th style={{width: "35%"}} >Descrição</th>
       <th style={{cursor: 'pointer', width: "15%" }} 
           onClick={() => changeOrder(0,1)}>
            Número  
            <TableArrowDown 
            active={orders[0].active} 
            reverse={orders[0].reverse} 
            className={`leftMargin ${orders[0].reverse ? 'arrow-margin-bottom' : ''}`} 
            />
       
       </th>

       <th style={{width: "25%"}} >Parâmetro
       </th>
       <th style={{width: "35%"}} >Valor</th>
       <th style={{width: "15%"}} className='text-center' >Copiar valor</th>

       <th  style={{width: "10%"}} className='text-center'>
         Visualizar
       </th>
       
       <th  style={{width: "10%"}}  className='text-center'>
         Editar
       </th>
      </tr>
    )

  const renderBody = () => {

    const renderRecord = (response, index) => {
      const { idBranch, dsParameter, nuParameter, dsKey, dsValue } = response

      const renderWithTooltip = (value, maxLength) => {
        if (value && value.length > maxLength) {
          const truncatedValue = value.slice(0, maxLength);
          return (
            <>
            <span className='list-description'>{truncatedValue}[...]</span>
            <span className='CellComment'>{value}</span>
            </>
          
          );
        }
        return value;
      };

      return (
        <tr key={index}>
        
            <td style={{width: "12%"}} > {idBranch === "0" ? "Todas" : idBranch}</td>
            <td className='CellWithComment' style={{ width: '35%', wordBreak: 'break-word' }}>{renderWithTooltip(dsParameter, 35)}</td>
            <td style={{width: "15%"}} >{nuParameter}</td>
            <td className='CellWithComment' style={{ width: '25%', wordBreak: 'break-word' }}>{renderWithTooltip(dsKey, 20)}</td>

            <td className='CellWithComment' style={{ width: '35%', wordBreak: 'break-word' }}>{renderWithTooltip(dsValue, 30)}</td>

            <td style={{ width: '15%' }} className='text-center'>
              <span
                className='copyValue'
                onClick={() => handleCopy(index, dsValue)}
                style={{ cursor: 'pointer', color: copiedRow === index ? '#158110' : '#41A017' }}
              >
                {copiedRow === index ? 'Copiado!' : 'Copiar'}
              </span>
            </td>
        
            <td onClick={() => openModal(response)} style={{width: "10%"}} className='text-center'>
                <i style={{cursor: 'pointer'}} className=' glyph glyph-eye icon-size color-primary' />
            </td>

            <td onClick={() => handleEditModal(response)}  style={{width: "10%"}} className='text-center'>
            <i style={{cursor: 'pointer'}} className=' glyph glyph-pencil icon-size color-primary' />
            </td>

        </tr>
      
      )
    }

    return parameters.map((response, index) => renderRecord(response, index))
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className={`supply-list-table-new new pictograms-table }`}>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
      <tfoot style={{height: "1px",background:"#D3D2D6", marginTop: "0.6rem"}}></tfoot>
    </table>
  )
}

NewTableSystemParameters.propTypes = {
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      idBranch: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      dsParameter: PropTypes.string.isRequired,
      nuParameter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      dsKey: PropTypes.string.isRequired,
      dsValue: PropTypes.string.isRequired,
    })
  ).isRequired,
  openModal: PropTypes.func.isRequired,
  handleOrder: PropTypes.func.isRequired,
  handleEditModal: PropTypes.func,
};

export default NewTableSystemParameters
